import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, PriceInput } from '@artosera/ui';
import { usePlancher, useFixerPlancher } from '../../api/presentation.js';
import { galerieALaction, galerieAModule, galerieEcritModule } from '../../auth/sujet.js';
import { useShellContext } from '../shell/context.js';
import { ErreurPresentation } from './ErreurPresentation.js';
import styles from './Presentation.module.css';

export function PlancherOeuvre({ oeuvreId, devise }: { oeuvreId: string; devise: string }) {
  const { galerie, galerieSlug, compte } = useShellContext();
  if (
    !galerieAModule(galerie, 'rendez-vous-client') ||
    !galerieALaction(galerie, 'artworks:read-artist-price')
  )
    return null;
  return (
    <ChampPlancher
      key={`${compte.id}:${galerieSlug}:${oeuvreId}`}
      oeuvreId={oeuvreId}
      devise={devise}
    />
  );
}
function ChampPlancher({ oeuvreId, devise }: { oeuvreId: string; devise: string }) {
  const { t, i18n } = useTranslation('presentation');
  const { galerieSlug, galerie } = useShellContext();
  const plancher = usePlancher(galerieSlug, oeuvreId);
  const fixer = useFixerPlancher(galerieSlug, oeuvreId);
  const peutEcrire =
    galerieALaction(galerie, 'artworks:write') && galerieEcritModule(galerie, 'rendez-vous-client');
  const [saisie, setSaisie] = useState<{ montant: number | null } | null>(null);
  return (
    <section className={styles.formulaire}>
      <div className={styles.champ}>
        <label htmlFor="prix-plancher">{t('plancher.titre')}</label>
        <PriceInput
          id="prix-plancher"
          optional
          cents={saisie ? saisie.montant : (plancher.data?.plancherCentimes ?? null)}
          onCentsChange={(montant) => setSaisie({ montant })}
          lang={i18n.language === 'en' ? 'en' : 'fr'}
          currency={devise}
          disabled={!peutEcrire || !plancher.data || fixer.isPending}
          aria-describedby="aide-plancher"
        />
      </div>
      <p id="aide-plancher" className={styles.aide}>
        {t('plancher.description')}
      </p>
      {plancher.isPending ? <p role="status">{t('chargement')}</p> : null}
      <ErreurPresentation
        erreur={plancher.error ?? fixer.error}
        recharger={() => {
          fixer.reset();
          setSaisie(null);
          void plancher.refetch();
        }}
      />
      {peutEcrire ? (
        <Button
          disabled={!saisie || !plancher.data}
          loading={fixer.isPending}
          onClick={() => {
            if (saisie) fixer.mutate(saisie.montant, { onSuccess: () => setSaisie(null) });
          }}
        >
          {t('plancher.enregistrer')}
        </Button>
      ) : null}
      {fixer.isSuccess ? <p role="status">{t('succes')}</p> : null}
    </section>
  );
}
